module.exports = __webpack_public_path__ + "all-dashboards-ic.svg?c28fec1e23b3a383503607ba3553c25f";